  (function () {
    var d = document.getElementById('CxMenuSheet');
    if (!d || d._cxMs) return;
    d._cxMs = true;
    var panels = {}, stack = ['root'];
    d.querySelectorAll('[data-cx-ms-p]').forEach(function (p) {
      panels[p.getAttribute('data-cx-ms-p')] = p;
      p.querySelectorAll('.cx-ms__list > li').forEach(function (li, i) { li.style.setProperty('--i', Math.min(i, 14)); });
    });
    function fillLl(p) {
      if (p._ll) return;
      p._ll = true;
      var ul = p.querySelector('[data-cx-ms-brands]'), base = p.getAttribute('data-base');
      fetch(p.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (j) {
        var b = (j.b || []).slice().sort(function (x, y) { return x[1].localeCompare(y[1]); });
        ul.innerHTML = b.map(function (x, i) {
          return '<li style="--i:' + Math.min(i, 14) + '"><a class="cx-ms__a" href="' + base + '/ll_marca_' + x[0] + '">' + x[1].replace(/</g, '&lt;') + '<small>' + x[2].toLocaleString('es-ES') + '</small></a></li>';
        }).join('');
      }).catch(function () { p._ll = false; });
    }
    function show(id, back) {
      var cur = panels[stack[stack.length - 1]], nx = panels[id] || (panels[id] = d.querySelector('[data-cx-ms-p="' + id + '"]'));
      if (!nx || cur === nx) return false;
      cur.classList.remove('is-active');
      cur.setAttribute('aria-hidden', 'true');
      if (!back) cur.classList.add('is-past');
      nx.classList.remove('is-past');
      nx.classList.add('is-active');
      nx.removeAttribute('aria-hidden');
      nx.scrollTop = 0;
      return true;
    }
    d.addEventListener('click', function (e) {
      var go = e.target.closest('[data-cx-ms-go]');
      if (go) {
        var id = go.getAttribute('data-cx-ms-go');
        if (panels[id] && panels[id].hasAttribute('data-cx-ms-ll')) fillLl(panels[id]);
        if (show(id)) stack.push(id);
        return;
      }
      if (e.target.closest('[data-cx-ms-back]') && stack.length > 1) {
        show(stack[stack.length - 2], true);
        stack.pop();
      }
    });
    function reset() {
      Object.keys(panels).forEach(function (k) {
        var p = panels[k];
        p.classList.remove('is-active', 'is-past');
        if (k === 'root') { p.classList.add('is-active'); p.removeAttribute('aria-hidden'); p.scrollTop = 0; }
        else p.setAttribute('aria-hidden', 'true');
      });
      stack = ['root'];
    }
    var rt;
    new MutationObserver(function () {
      clearTimeout(rt);
      if (!d.classList.contains('is-open')) rt = setTimeout(reset, 650);
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    var g = d.querySelector('[data-cx-ms-grab]'), y0 = null, dy = 0;
    if (g) {
      g.addEventListener('pointerdown', function (e) { y0 = e.clientY; dy = 0; d.classList.add('is-dragging'); try { g.setPointerCapture(e.pointerId); } catch (_) {} });
      g.addEventListener('pointermove', function (e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); d.style.setProperty('--ms-drag', dy + 'px'); });
      var end = function () {
        if (y0 === null) return;
        y0 = null;
        d.classList.remove('is-dragging');
        d.style.removeProperty('--ms-drag');
        if (dy > 100) { var c = d.querySelector('[data-cx-close]'); c && c.click(); }
      };
      g.addEventListener('pointerup', end);
      g.addEventListener('pointercancel', end);
    }
  })();
